import { runSmartSubnav } from '../../snippets/smart-subnav/smart-subnav';
import { initReviewsCarousel } from './smart-home-control-reviews/smart-home-control-reviews';
import { initPhotoSlider } from './smart-home-control-photo-frame/smart-home-control-photo-frame';
import { initProducts } from './smart-home-control-products/smart-home-control-products';
import YTPlayer from '../../scripts/components/YTPlayer';
import { initVideoAutoplayControls } from '../../scripts/utils/videoAutoplayControls/videoAutoplayControls';
import { initInstallationSlider } from '../../snippets/installation-slider/installation-slider';

window.onReady(() => {
  runSmartSubnav({
    intersectionThreshold: 0.6,
    intersectionRatio: 0.6,
  });
  initVideoAutoplayControls();
  initReviewsCarousel();
  initInstallationSlider();
  initPhotoSlider();
  initProducts();
  YTPlayer.init();
});
